import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { articles, categories } from "@/mocks/articles";

const imageMap: Record<string, string> = {
  "article-01": "https://readdy.ai/api/search-image?query=Dramatic%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20with%20warm%20amber%20street%20lights%2C%20blurred%20figures%20at%20the%20doorway%2C%20moody%20atmosphere%20with%20deep%20shadows%2C%20cinematic%20composition%2C%20dark%20tones%20with%20golden%20accents%2C%20editorial%20photography%20style&width=600&height=450&seq=article-01&orientation=landscape",
  "article-02": "https://readdy.ai/api/search-image?query=Luxurious%20wedding%20ceremony%20with%20elaborate%20floral%20arrangements%2C%20soft%20golden%20lighting%2C%20elegant%20banquet%20hall%20setting%2C%20romantic%20and%20opulent%20atmosphere%2C%20warm%20tones%2C%20shallow%20depth%20of%20field%2C%20editorial%20wedding%20photography&width=600&height=450&seq=article-02&orientation=landscape",
  "article-03": "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20smartphone%20screen%20showing%20a%20live%20streaming%20interface%20with%20bright%20colorful%20overlay%2C%20modern%20streaming%20setup%20with%20ring%20light%2C%20slightly%20blurred%20background%2C%20vibrant%20saturated%20tones%2C%20contemporary%20digital%20culture%20photography&width=600&height=450&seq=article-03&orientation=landscape",
  "article-04": "https://readdy.ai/api/search-image?query=Split%20scene%20composition%20showing%20contrast%20between%20professional%20office%20setting%20on%20left%20and%20vibrant%20nightclub%20atmosphere%20on%20right%2C%20dramatic%20lighting%20contrast%2C%20cinematic%20storytelling%2C%20moody%20tones%2C%20conceptual%20portrait%20photography&width=600&height=450&seq=article-04&orientation=landscape",
  "article-05": "https://readdy.ai/api/search-image?query=Dimly%20lit%20private%20party%20scene%20with%20elegant%20interior%2C%20silhouettes%20and%20ambient%20lighting%20creating%20mystery%2C%20luxurious%20modern%20penthouse%20atmosphere%2C%20deep%20shadows%20with%20warm%20accent%20lighting%2C%20cinematic%20mood%20photography&width=600&height=450&seq=article-05&orientation=landscape",
  "article-06": "https://readdy.ai/api/search-image?query=Mysterious%20entrance%20of%20an%20exclusive%20private%20club%20with%20subdued%20amber%20lighting%2C%20polished%20dark%20wood%20and%20brass%20details%2C%20sense%20of%20secrecy%20and%20exclusivity%2C%20cinematic%20noir%20atmosphere%2C%20rich%20dark%20tones%20with%20golden%20highlights&width=600&height=450&seq=article-06&orientation=landscape",
  "article-07": "https://readdy.ai/api/search-image?query=Empty%20modern%20office%20at%20night%20with%20scattered%20documents%20and%20dim%20desk%20lamps%2C%20exhausted%20atmosphere%2C%20corporate%20environment%20with%20cold%20fluorescent%20lighting%20mixed%20with%20warm%20desk%20lamps%2C%20documentary%20style%20photography&width=600&height=450&seq=article-07&orientation=landscape",
  "article-08": "https://readdy.ai/api/search-image?query=Inspiring%20scene%20of%20a%20determined%20young%20entrepreneur%20working%20at%20a%20simple%20desk%20setup%20with%20warm%20natural%20light%20streaming%20through%20window%2C%20rustic%20countryside%20background%2C%20hopeful%20and%20uplifting%20atmosphere%2C%20warm%20golden%20hour%20tones%2C%20documentary%20portrait%20photography&width=600&height=450&seq=article-08&orientation=landscape",
  "article-09": "https://readdy.ai/api/search-image?query=Modern%20corporate%20building%20exterior%20with%20subtle%20regulatory%20atmosphere%2C%20clean%20architectural%20lines%2C%20overcast%20sky%20creating%20serious%20mood%2C%20documentary%20architectural%20photography%2C%20muted%20color%20palette&width=600&height=450&seq=article-09&orientation=landscape",
  "article-10": "https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20digital%20network%20connections%20with%20warm%20amber%20and%20gold%20nodes%20against%20dark%20background%2C%20representing%20complex%20systems%20and%20connections%2C%20modern%20data%20visualization%20aesthetic%2C%20sophisticated%20dark%20theme%20with%20glowing%20elements&width=600&height=450&seq=article-10&orientation=landscape",
  "article-11": "https://readdy.ai/api/search-image?query=Mysterious%20anonymous%20figure%20silhouette%20against%20computer%20screen%20glow%20in%20dark%20room%2C%20hacker%20or%20online%20identity%20theme%2C%20dramatic%20chiaroscuro%20lighting%2C%20cyber%20mystery%20atmosphere%2C%20dark%20tones%20with%20monitor%20blue%20white%20light%2C%20thriller%20photography%20style&width=600&height=450&seq=article-11&orientation=landscape",
  "article-12": "https://readdy.ai/api/search-image?query=Collage%20style%20composition%20of%20newspaper%20headlines%20and%20digital%20news%20snippets%2C%20organized%20chaos%20aesthetic%2C%20warm%20paper%20tones%20mixed%20with%20modern%20digital%20elements%2C%20editorial%20layout%20photography%2C%20rich%20textures%20and%20layers&width=600&height=450&seq=article-12&orientation=landscape",
};

const heroImageMap: Record<string, string> = {
  "article-01": "https://readdy.ai/api/search-image?query=Dramatic%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20with%20warm%20amber%20street%20lights%2C%20blurred%20figures%20at%20the%20doorway%2C%20moody%20atmosphere%20with%20deep%20shadows%2C%20cinematic%20composition%2C%20dark%20tones%20with%20golden%20accents&width=800&height=600&seq=hero-card-01&orientation=landscape",
  "article-06": "https://readdy.ai/api/search-image?query=Mysterious%20entrance%20of%20an%20exclusive%20private%20club%20with%20subdued%20amber%20lighting%2C%20polished%20dark%20wood%20and%20brass%20details%2C%20cinematic%20noir%20atmosphere%2C%20rich%20dark%20tones%20with%20golden%20highlights&width=800&height=600&seq=hero-card-06&orientation=landscape",
  "article-04": "https://readdy.ai/api/search-image?query=Split%20scene%20showing%20contrast%20between%20professional%20office%20and%20vibrant%20nightclub%2C%20dramatic%20lighting%20contrast%2C%20cinematic%20storytelling%2C%20moody%20tones%2C%20conceptual%20portrait%20photography&width=800&height=600&seq=hero-card-04&orientation=landscape",
};

function HeroSection() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 3);
  return (
    <section className="relative w-full min-h-[620px] flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20artistic%20background%20with%20flowing%20amber%20and%20deep%20crimson%20gradients%2C%20soft%20textured%20layers%2C%20modern%20minimalist%20aesthetic%2C%20dark%20edges%20with%20warm%20center%20glow%2C%20atmospheric%20depth%2C%20no%20text%2C%20cinematic%20lighting%2C%20abstract%20expressionist%20style&width=1920&height=800&seq=hero-bg-2026&orientation=landscape"
          alt="每日吃瓜黑料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-16 flex flex-col items-center">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-extrabold text-background-50 leading-tight tracking-tight">
            全网热点
          </h1>
          <p className="text-2xl md:text-4xl lg:text-5xl font-heading font-extrabold text-background-50 leading-tight mt-2">
            每日新料
          </p>
          <p className="text-xl md:text-3xl lg:text-4xl font-heading font-extrabold text-primary-400 leading-tight mt-2">
            吃瓜不打烊
          </p>
          <div className="mt-8">
            <Link
              to="/category/wangbaomen"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即吃瓜 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full max-w-5xl">
          {hotArticles.map((article, i) => {
            const imgUrl = heroImageMap[article.imageSeq] || heroImageMap["article-01"];
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className={`group relative rounded-xl overflow-hidden cursor-pointer ${
                  i === 1 ? "md:-mt-4 md:z-20" : "md:mt-2 md:z-10"
                }`}
              >
                <div className="aspect-[4/3] w-full">
                  <img
                    src={imgUrl}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    title={article.title}
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                {article.isExclusive && (
                  <span className="absolute top-3 right-3 px-3 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                    独家
                  </span>
                )}
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white text-sm md:text-base font-heading font-bold leading-snug line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-white/70 text-xs mt-1">{article.views} 阅读</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function HotGrid() {
  const displayArticles = articles.slice(0, 8);
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门吃瓜</h2>
            <p className="text-sm text-foreground-500 mt-2">7×24小时实时更新，黑料不打烊</p>
          </div>
          <Link
            to="/category/wangbaomen"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {displayArticles.map((article) => {
            const imgUrl = imageMap[article.imageSeq] || imageMap["article-01"];
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group relative rounded-xl overflow-hidden bg-background-100 cursor-pointer"
              >
                <div className="aspect-[4/3] w-full">
                  <img
                    src={imgUrl}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    title={article.title}
                  />
                </div>
                <div className="absolute top-3 right-3 flex gap-2">
                  {article.tags.map((tag) => (
                    <span key={tag} className="px-2.5 py-1 bg-secondary-500/90 text-background-50 text-xs font-medium rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white text-sm font-heading font-bold leading-snug line-clamp-2">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-2 text-white/70 text-xs">
                    <span><i className="ri-eye-line mr-1"></i>{article.views}</span>
                    <span><i className="ri-chat-3-line mr-1"></i>{article.comments}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function CategoryNav() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-block px-3 py-1 border border-foreground-300 text-xs text-foreground-500 rounded-full">频道导航</span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mt-4 leading-tight">
            全网黑料
          </h2>
          <p className="text-xl md:text-3xl font-heading font-bold text-foreground-950 leading-tight">
            一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-6 md:p-8 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-5">
                <i className={`${cat.icon} text-3xl text-foreground-800`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-5 flex items-center gap-1 text-sm text-primary-500 font-medium">
                进入频道 <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function CommunityCTA() {
  return (
    <section className="w-full">
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2 relative h-[400px] lg:h-[500px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20gathering%20of%20diverse%20young%20people%20at%20a%20modern%20cafe%20lounge%2C%20sharing%20stories%20and%20laughing%2C%20warm%20golden%20lighting%2C%20cozy%20interior%20with%20exposed%20brick%20walls%20and%20hanging%20edison%20bulbs%2C%20candid%20documentary%20style%20photography%2C%20rich%20amber%20and%20brown%20tones%2C%20genuine%20expressions%2C%20community%20vibe&width=960&height=600&seq=community-left-2026&orientation=landscape"
            alt="吃瓜社区"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
          <div className="absolute top-8 left-8">
            <span className="text-xs text-white/70 font-medium tracking-wider uppercase">吃瓜社区</span>
          </div>
          <div className="absolute bottom-8 left-8">
            <p className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight">
              千万瓜友
            </p>
            <p className="text-xl md:text-3xl lg:text-4xl font-heading font-bold text-white/80 leading-tight">
              在线讨论
            </p>
            <p className="text-lg md:text-2xl lg:text-3xl font-heading font-bold text-primary-400 leading-tight">
              欢迎回家
            </p>
          </div>
        </div>

        <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-6 py-16 md:py-20">
          <div className="max-w-md text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">加入吃瓜社区</h2>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              每天都有千万瓜友在这里讨论最新爆料，分享独家内幕消息。在这里，你不是一个人在战斗。一起见证娱乐圈的风云变幻，参与最火热的话题讨论。
            </p>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              51fun、51cg、海角社区——你的吃瓜根据地。每日精品内容实时推送，首页、论坛一站式浏览，万里长征吃瓜路，我们陪你走到底！
            </p>
            <div className="mt-8">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-900 text-background-50 rounded-full text-base font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function StructuredData() {
  const origin = typeof window !== "undefined" ? window.location.origin : "http://28i7.com/";
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 3);
  const allArticles = articles.slice(0, 8);

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "每日吃瓜黑料",
        url: origin,
        logo: `${origin}/favicon.png`,
        description: "每日吃瓜黑料为你提供最新最全的黑料爆料内容，免费吃瓜，黑料每日更新。",
        sameAs: ["http://28i7.com/mrcg"],
        contactPoint: {
          "@type": "ContactPoint",
          email: "hello@28i7.com",
          contactType: "customer service",
        },
      },
      {
        "@type": "WebSite",
        url: origin,
        name: "每日吃瓜黑料",
        description: "每日吃瓜黑料 - 每日新料吃瓜网，吃瓜中心，呱呱吃瓜爆料黑料网曝门黑料，今日吃瓜热门大瓜必看",
        potentialAction: {
          "@type": "SearchAction",
          target: `${origin}/search?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "WebPage",
        url: origin,
        name: "首页 - 每日吃瓜黑料",
        description: "每日吃瓜黑料为你提供最新、最全、最热的黑料爆料内容。免费吃瓜，黑料每日更新。",
        mainEntity: {
          "@type": "ItemList",
          itemListElement: allArticles.map((article, i) => ({
            "@type": "ListItem",
            position: i + 1,
            url: `${origin}/article/${article.slug}`,
            name: article.title,
          })),
        },
      },
      {
        "@type": "ItemList",
        name: "热门吃瓜推荐",
        itemListElement: hotArticles.map((article, i) => ({
          "@type": "ListItem",
          position: i + 1,
          url: `${origin}/article/${article.slug}`,
          name: article.title,
        })),
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "每日吃瓜黑料是做什么的？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "每日吃瓜黑料是一个专注于娱乐八卦爆料、网红黑料、明星绯闻和社会热点的聚合平台。我们7x24小时监控全网爆料动态，为用户提供最新、最全、最热的黑料内容。",
            },
          },
          {
            "@type": "Question",
            name: "吃瓜的内容都是免费的吗？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "是的，每日吃瓜黑料所有内容完全免费。我们承诺不向用户收取任何费用，免费吃瓜是我们的核心宗旨。",
            },
          },
          {
            "@type": "Question",
            name: "每日吃瓜黑料有哪些频道？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "我们涵盖网曝门、明星绯闻、网红八卦、社会热点、独家爆料、行业揭秘等多个频道，满足不同吃瓜爱好者的需求。",
            },
          },
          {
            "@type": "Question",
            name: "如何在每日吃瓜黑料投稿爆料？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "你可以通过网站订阅入口提交爆料信息，或发送邮件至 hello@28i7.com。我们将严格保护爆料人隐私，所有投稿内容均经过审核后发布。",
            },
          },
        ],
      },
    ],
  };

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
  );
}

export default function Home() {
  return (
    <>
      <StructuredData />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotGrid />
          <CategoryNav />
          <CommunityCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}
